// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"BasicTag--next-sr-only--2Sih7KI","tag":"BasicTag--tag--6xzN41U"};